var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.ServiceWorkerHandler = {
    worker: null,
    // Actions
    send_worker_message: function (msg) {
        if (this.worker) {
            try {
                /* istanbul ignore if */
                if (msg.options && msg.options.arraybuffer instanceof ArrayBuffer) {
                    this.worker.postMessage(msg, [msg.options.arraybuffer]);
                    delete msg.options.arraybuffer;
                } else {
                    this.worker.postMessage(msg);
                }
                delete msg.options;
                delete msg.cmd;
                return true;
            } catch (e) {
                if(!msg.retries) {
                    msg.retries = 1;
                } else {
                    msg.retries++;
                }                
                console.warn("Worker Handler: Failed to send message.", e);
                return false;
            }
        } else {
            console.warn("Worker Handler: Worker not available.");
            return false;
        }
    },
    stop_worker: function () {
        
    },
    // Event Listeners
    on_init_timeout: function () {
        /* istanbul ignore next */
        if (navigator.serviceWorker && !navigator.serviceWorker.controller) {
            try {
                navigator.serviceWorker.register(this.options.path).then(this.on_worker_registration_success.bind(this), this.on_worker_registration_error.bind(this));
            } catch (e) {
                /* istanbul ignore next */
                console.warn("Worker: Failed to load service worker!");
            }
            this.worker = navigator.serviceWorker.controller;
        }
    },    
    on_status_message: function (data) {
        var status = data.options;
        this.fireEvent(this.options.events.worker_status_update, data);
        if (status.online_status === 'online') {
            if (this.online_status !== status.online_status) {
                // Our online state has changed
                this.online_status = "online";
                this.fireEvent(this.options.events.worker_online, this);
                // Send the initialization message if we have it
                /* istanbul ignore if */
                if (Object.keys(this.init_msg.options).length) {
                    this.send_worker_message(this.init_msg);
                }                
            }
            this.set_status(status.status);
            if (status.status === this.options.idle_text) {
                if (this.msg_queue.length) {
                    this.set_status(this.options.active_text);
                    setTimeout(this.send_from_msg_queue.bind(this), this.options.time_to_msg_queue);
                } else {
                    this.clear_active_request();
                    // We have nothing in the queue, lets inform everyone we are idle
                    this.fireEvent(this.options.events.worker_idle, this);
                }
            }
        } else {
            this.fireEvent(this.options.events.worker_terminated, this);
        }
    },
    on_worker_finished: function () {
        this.clear_active_request();
        this.set_status(this.options.idle_text);
    },
    on_worker_message: function (oEvent) {
        if (!oEvent.data) {
            return false; // Ignore messages without a worker id
        }
        if (oEvent.data.cmd === 'status' && oEvent.data.options.status !== this.status) {
            this.on_status_message(oEvent.data);
            return true;
        }

        this.fireEvent(this.options.events.worker_msg_recieved, oEvent);
        if (this.onmessage) {
            this.onmessage(oEvent.data);
        }

        if (oEvent.data.cmd !== "status" && this.active_request) {
            /* istanbul ignore if */
            if (this.active_request.callback) {
                this.active_request.callback(oEvent.data);
            }
            if (this.active_request.one_time_callback) {
                this.active_request.one_time_callback(oEvent.data);
                this.active_request.one_time_callback = null;
                delete this.active_request.one_time_callback;
            }
            /* istanbul ignore if */
            if (oEvent.data.cmd === "data" && this.active_request.data_callback) {
                this.active_request.data_callback(oEvent.data);
            }
        }
        return true;

    },
    on_worker_registration_error: function (err) {
        console.log('ServiceWorker registration failed: ', err);
    },
    on_worker_registration_success: function (registration) {
        // Registration was successful
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
        navigator.serviceWorker.addEventListener('message', this.on_worker_message.bind(this));
    }
};